module.exports = __webpack_public_path__ + "img/17847_L.d8849738.png";